const SurveyListSortableFields = {
  NAME: 'name',
  STATUS: 'status',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  RESPONSES: 'answered_response_count',
  FIRST_AND_LAST_NAME: 'updater.first_name,updater.last_name',
};

export default SurveyListSortableFields;
